'use strict';
import angular from 'angular';

angular.module('preferences.directives', []);